<template>
  <add-edit-dialog>
    <crm-panel title="编辑合同">
      <div class="page-buttons">
        <crm-button
          :text="'保存'"
          :disabled="isSubmitDisabled"
          @click="handleSave()"
        >
        </crm-button>
        <crm-button :buttonType="'plain'" :text="'取消'" @click="handleClose()">
        </crm-button>
      </div>
      <el-form
        label-position="right"
        label-width="150px"
        :rules="rules"
        ref="form"
        :model="form"
        class="add-edit-form"
      >
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item
              label="合同类型："
              prop="contractType"
              :rules="{ required: true }"
            >
              <el-input v-model="form.contractTypeName" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8" v-if="contractModule !== 1">
            <el-form-item label="客户名称：" prop="customerId" :rules="{ required: true }">
              <el-input v-model="form.customerName" disabled></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item
              label="客户名称："
              prop="customerId"
              :rules="{ required: true }"
            >
              <el-input v-model="form.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="业务员："
              prop="salesmanCode"
              v-if="contractModule"
            >
              <el-select
                @change="salesSelected"
                clearable
                v-model="form.salesmanCode"
              >
                <el-option
                  :key="item.salesmanCode"
                  v-for="item in customSalesman"
                  :label="item.salesmanName"
                  :value="item.salesmanCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="contractModule === 1">
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合同编号：" prop="contractNo">
                <el-input
                  v-model="form.contractNo"
                  name="contractNo"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关联商机：">
                <el-select
                  clearable
                  filterable
                  remote
                  placeholder="请选择商机名称"
                  @focus="handleBusiSelectFocus"
                  @change="handleBusiSelectChange"
                  @clear="handleBusiSelectClear"
                  :remote-method="handleBusiSearch"
                  :loading="selectBusiData.loading"
                  v-model="form.businessId"
                >
                  <el-option
                    v-for="item in selectBusiList"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  >
                    <el-tooltip
                      v-if="item.name.length > 40"
                      class="item custom-select-item"
                      effect="dark"
                      :content="item.name"
                      placement="top"
                    >
                      <span>{{ item.name }}</span>
                    </el-tooltip>
                    <span v-else>{{ item.name }}</span>
                  </el-option>
                  <el-option
                    v-if="
                      busiSelectData.totalCount > selectBusiData.pageSize &&
                        selectBusiData.pageIndex < busiSelectData.totalPages
                    "
                    label="点击加载更多"
                    value="点击加载更多"
                    :disabled="true"
                    style="cursor:pointer;"
                  >
                    <span @click="handleMoreBusiList()">点击加载更多</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="产品线：" prop="businessLine">
                <!-- <el-select clearable v-model="form.businessLine">
                  <el-option
                    :key="item.uid"
                    v-for="item in busiLineList"
                    :label="item.name"
                    :value="item.uid">
                  </el-option>
                </el-select> -->
                <el-cascader
                  ref="cascader"
                  :show-all-levels="false"
                  :options="allProductLine"
                  :props="{
                    value: 'id',
                    label: 'name',
                    children: 'productLineList',
                    emitPath: false,
                    multiple: true,
                  }"
                  clearable
                  placeholder="请选择"
                  v-model="form.businessLine"
                  @change="handleChange"
                >
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="合作模式：" prop="coopMode">
                <el-select clearable v-model="form.coopMode">
                  <el-option
                    :key="item.uid"
                    v-for="item in modeTypeList"
                    :label="item.name"
                    :value="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="签约形式：" prop="signingForm">
                <el-select
                  placeholder="请选择签约形式"
                  clearable
                  v-model="form.signingForm"
                >
                  <el-option
                    v-for="item in signingForm"
                    :label="item.name"
                    :value="item.uid"
                    :key="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8"> </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item
                label="签订日期："
                class="date-add-return"
                prop="signDate"
              >
                <el-date-picker
                  :editable="false"
                  value-format="yyyy-MM-dd"
                  v-model="form.signDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合同金额(元)：" prop="contractAmountStr">
                <el-input
                  v-model="form.contractAmountStr"
                  name="contractAmountStr"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结算方式：" prop="settlementType">
                <el-select clearable v-model="form.settlementType">
                  <el-option
                    v-for="item in settlementType"
                    :label="item.name"
                    :value="item.uid"
                    :key="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="contractModule === 2">
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合同编号：" prop="contractNo">
                <el-input
                  v-model="form.contractNo"
                  name="contractNo"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="签订日期："
                class="date-add-return"
                prop="signDate"
              >
                <el-date-picker
                  :editable="false"
                  value-format="yyyy-MM-dd"
                  v-model="form.signDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合作科室：" prop="departmentIds">
                <el-select clearable v-model="form.departmentIds" multiple>
                  <el-option
                    :key="item.uid"
                    v-for="item in coprationDepartment"
                    :label="item.name"
                    :value="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="合同金额(元)：" prop="contractAmountStr">
                <el-input
                  v-model="form.contractAmountStr"
                  name="contractAmountStr"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="contractModule === 3">
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合同编号：" prop="contractNo">
                <el-input
                  v-model="form.contractNo"
                  name="contractNo"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="签订日期："
                class="date-add-return"
                prop="signDate"
              >
                <el-date-picker
                  :editable="false"
                  value-format="yyyy-MM-dd"
                  v-model="form.signDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合作科室：" prop="departmentIds">
                <el-select clearable v-model="form.departmentIds" multiple>
                  <el-option
                    :key="item.uid"
                    v-for="item in coprationDepartment"
                    :label="item.name"
                    :value="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="科室综合收入比例：" prop="incomeRatio">
                <el-input v-model="form.incomeRatio"></el-input>
                <span style="position: absolute; top: 0px; right: 10px;"
                  >%</span
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合同金额(元)：" :rules="{ required: true }">
                <el-input v-model="totalContractMoney" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="岗前培训费(元)：" prop="preJobTrainingStr">
                <el-input v-model="form.preJobTrainingStr"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="驻点带教费(元)：" prop="residentTeachStr">
                <el-input v-model="form.residentTeachStr"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="定期带教费(元)：" prop="regularTeachStr">
                <el-input v-model="form.regularTeachStr"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="多点执业费(元)："
                prop="multipointPracticeStr"
              >
                <el-input v-model="form.multipointPracticeStr"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="运营启动费(元)：" prop="operateStartedStr">
                <el-input v-model="form.operateStartedStr"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="运营运维费(元)：" prop="operateOperationStr">
                <el-input v-model="form.operateOperationStr"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="合同开始日期：" prop="startDate">
              <el-date-picker
                :editable="false"
                value-format="yyyy-MM-dd"
                v-model="form.startDate"
                name="startDate"
                type="date"
                :picker-options="startDateLimit"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同结束日期：" prop="endDate">
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="form.endDate"
                name="endDate"
                type="date"
                :picker-options="endDateLimit"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :offset="3">
            <el-form-item label="备注：" prop="remarks">
              <el-input
                type="textarea"
                placeholder="不超过200字"
                :rows="4"
                v-model="form.remarks"
                name="remarks"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import crmButton from '@/components/base/crmButton';
import crmPanel from '@/components/base/crmPanel';
import AddEditDialog from '@/components/base/addEditDialog';
import service from '@/services/api/compact';

export default {
  components: {
    crmButton,
    crmPanel,
    AddEditDialog,
  },
  props: {
    id: {
      type: String,
    },
    contractType: {
      type: String,
    },
  },
  data() {
    const totalMoneyRule = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error('请输入最多两位小数且无逗号的数字'));
      } else if (value > 999999999.99) {
        callback(new Error('最大999999999.99'));
      } else {
        callback();
      }
    };
    const incomeRatioRule = (rule, value, callback) => {
      if (
        !/^100$|^(\d|[1-9]\d)(\.\d{0,2})*$/.test(value)
        && value !== '100.00'
      ) {
        callback(new Error('请输入最多两位小数0-100的数字'));
      } else {
        callback();
      }
    };
    const moneyRule = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error('请输入最多两位小数且无逗号的数字'));
      } else if (value > 99999999.99) {
        callback(new Error('最大99999999.99'));
      } else {
        callback();
      }
    };
    return {
      startDateLimit: {
        disabledDate: (time) => {
          if (!this.form.endDate) return false;
          return time.getTime() >= new Date(this.form.endDate).getTime();
        },
      },
      endDateLimit: {
        disabledDate: (time) => {
          if (!this.form.startDate) return false;
          return (
            time.getTime()
            <= new Date(this.form.startDate).getTime() - 1 * 24 * 3600 * 1000
          );
        },
      },
      loading: false,
      // 合同模板
      contractModule: null,
      form: {},
      // 业务员下拉框
      customSalesman: [],
      // 商机名称
      // searchBusi: '',
      // 商机下拉列表
      selectBusiData: {
        loading: false,
        query: '',
        pageIndex: 1,
        pageSize: 5,
      },
      selectBusiList: [],
      allProductLine: [],
      rules: {},
      rules1: {
        customerId: [
          { required: true, message: '请选择客户名称', trigger: 'change' },
        ],
        contractNo: [
          { required: true, message: '请填写合同编号', trigger: 'blur' },
          { max: 50, message: '不超过50个字', trigger: 'blur' },
        ],
        signDate: [
          { required: true, message: '请选择签订日期', trigger: 'change' },
        ],
        businessLine: [
          { required: true, message: '请选择产品线', trigger: 'change' },
        ],
        signingForm: [
          { required: true, message: '请选择签约形式', trigger: 'change' },
        ],
        contractAmountStr: [{ validator: totalMoneyRule, trigger: 'blur' }],
        remarks: [{ max: 200, message: '不超过200个字', trigger: 'blur' }],
      },
      rules2: {
        customerId: [
          { required: true, message: '请选择客户名称', trigger: 'change' },
        ],
        contractNo: [
          { required: true, message: '请填写合同编号', trigger: 'blur' },
          { max: 50, message: '不超过50个字', trigger: 'blur' },
        ],
        signDate: [
          { required: true, message: '请选择签订日期', trigger: 'change' },
        ],
        departmentIds: [
          { required: true, message: '请选择合作科室', trigger: 'change' },
        ],
        contractAmountStr: [
          { required: true, validator: totalMoneyRule, trigger: 'blur' },
        ],
        remarks: [{ max: 500, message: '不超过500个字', trigger: 'blur' }],
        startDate: [
          { required: true, message: '请选择合同开始日期', trigger: 'change' },
        ],
        endDate: [
          { required: true, message: '请选择合同结束日期', trigger: 'change' },
        ],
      },
      rules3: {
        customerId: [
          { required: true, message: '请选择客户名称', trigger: 'change' },
        ],
        contractNo: [
          { required: true, message: '请填写合同编号', trigger: 'blur' },
          { max: 50, message: '不超过50个字', trigger: 'blur' },
        ],
        signDate: [
          { required: true, message: '请选择签订日期', trigger: 'change' },
        ],
        departmentIds: [
          { required: true, message: '请选择合作科室', trigger: 'change' },
        ],
        incomeRatio: [
          {
            required: true,
            message: '请填写科室综合收入比例',
            trigger: 'blur',
          },
          { validator: incomeRatioRule, trigger: 'blur' },
        ],
        preJobTrainingStr: [
          { required: true, message: '请填写岗前培训费', trigger: 'blur' },
          { validator: moneyRule, trigger: 'blur' },
        ],
        residentTeachStr: [
          { required: true, message: '请填写驻点带教费', trigger: 'blur' },
          { validator: moneyRule, trigger: 'blur' },
        ],
        regularTeachStr: [
          { required: true, message: '请填写定期带教费', trigger: 'blur' },
          { validator: moneyRule, trigger: 'blur' },
        ],
        multipointPracticeStr: [
          { required: true, message: '请填写多点执业费', trigger: 'blur' },
          { validator: moneyRule, trigger: 'blur' },
        ],
        operateStartedStr: [
          { required: true, message: '请填写运营启动费', trigger: 'blur' },
          { validator: moneyRule, trigger: 'blur' },
        ],
        operateOperationStr: [
          { required: true, message: '请填写运营运维费', trigger: 'blur' },
          { validator: moneyRule, trigger: 'blur' },
        ],
        startDate: [
          { required: true, message: '请选择合同开始日期', trigger: 'change' },
        ],
        endDate: [
          { required: true, message: '请选择合同结束日期', trigger: 'change' },
        ],
        remarks: [{ max: 200, message: '不超过200个字', trigger: 'blur' }],
      },
      isSubmitDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      compactDetail: 'compact/compactDetail',
      compactType: 'compact/compactType',
      customSelectData: 'compact/customSelectData',
      busiSelectData: 'compact/busiSelectData',
      settlementType: 'compact/settlementType',
      busiLineList: 'business/busiLineList',
      coprationDepartment: 'compact/coprationDepartment',
      signingForm: 'compact/signingForm',
      compactSalesman: 'compact/compactSalesman',
      modeTypeList: 'common/modeTypeList',
    }),

    // 避免商机下拉框点击更多数据时搜索关键字消失
    // searchBusi() {
    //   return this.form.businessId || this.selectBusiData.query;
    // },
    totalContractMoney() {
      return (
        (this.form.preJobTrainingStr * 100
          + this.form.residentTeachStr * 100
          + this.form.regularTeachStr * 100
          + this.form.multipointPracticeStr * 100
          + this.form.operateStartedStr * 100
          + this.form.operateOperationStr * 100)
        / 100
      );
    },
  },
  created() {
    this.loading = true;
    this.getCompactDetail({ id: this.id }).then(() => {
      this.form = this.compactDetail;
      this.form.businessLine = this.compactDetail.businessLine.split(',');
      this.busiSearchCustomId = this.compactDetail.customerId;
      this.busiSelectSearchUid = this.compactDetail.businessId;

      this.handleGetSalesman({ customerUid: this.compactDetail.customerId });
      this.getBusiSelectList();
      // this.searchBusi();
      this.loading = false;
    });
    if (
      this.contractType === '21cbef6460f249f1ba39716e60922117'
      || this.contractType === 'cbb006bf8d35416fb6cd28442c570f38'
    ) {
      this.rules = this.rules2;
      this.contractModule = 2;
    } else if (this.contractType === '8629ff61554941f282146ce6cbba3856') {
      this.rules = this.rules3;
      this.contractModule = 3;
    } else {
      this.rules = this.rules1;
      this.contractModule = 1;
    }
    // 获取产品线
    this.getAllProductLine();
    // 获取合作模式
    if (this.modeTypeList.length === 0) {
      this.getModeType({
        pageNumber: 1,
        pageSize: 100,
        code: 'category_mode_type',
      });
    }
    // 获取结算方式
    if (this.settlementType.length === 0) {
      this.getSettlementTypeList({
        pageNumber: 1,
        pageSize: 100,
        code: 'category_settlement_type',
      });
    }
    // 获取合作科室
    if (this.coprationDepartment.length === 0) {
      this.getCoprationDepartmentList({
        pageNumber: 1,
        pageSize: 100,
        code: 'category_department',
      });
    }
    // 获取签约形式
    if (this.signingForm.length === 0) {
      this.getSigningFormList({
        pageNumber: 1,
        pageSize: 100,
        code: 'category_signing_form',
      });
    }
  },
  methods: {
    ...mapActions({
      getCompactDetail: 'compact/getCompactDetail',
      getCompactTypeList: 'compact/getCompactTypeList',
      customSelectSearch: 'compact/customSelectSearch',
      busiSelectSearch: 'compact/busiSelectSearch',
      getBusiLineList: 'business/getBusiLineList',
      getSettlementTypeList: 'compact/getSettlementTypeList',
      updateCompact: 'compact/updateCompact',
      getCoprationDepartmentList: 'compact/getCoprationDepartmentList',
      getSigningFormList: 'compact/getSigningFormList',
      getCompactSalesman: 'compact/getCompactSalesman',
      getModeType: 'common/getModeType',
    }),
    handleClose() {
      this.$emit('close');
    },
    // 新增
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isSubmitDisabled = true;
          if (this.contractModule === 3) {
            this.form.contractAmountStr = this.totalContractMoney;
          }
          const params = {};
          Object.keys(this.form).forEach((item) => {
            if (this.form[item]) {
              params[item] = this.form[item];
            }
          });
          const { businessLine, ...otherParams } = params;
          this.updateCompact({
            ...otherParams,
            businessLine: this.form.businessLine.toString(),
            businessLineList: this.form.businessLine,
          })
            .then(() => {
              this.$message({
                type: 'success',
                message: '修改合同成功',
              });
              this.$emit('close');
              this.$emit('success');
            })
            .finally(() => {
              this.isSubmitDisabled = false;
            });
        }
      });
    },
    // 商机下拉框 聚焦时请求数据
    handleBusiSelectFocus() {
      // if (this.form.businessId) return;
      this.selectBusiData.pageIndex = 1;
      this.selectBusiData.query = '';
      this.getBusiSelectList();
    },
    handleBusiSelectChange(value) {
      this.form.businessId = value;
    },
    handleBusiSelectClear() {
      this.selectBusiData.query = '';
    },
    handleBusiSearch(query) {
      this.selectBusiData.query = query;
      this.selectBusiData.pageIndex = 1;
      this.getBusiSelectList();
    },
    // 选择业务员后，更新表单，
    salesSelected(value) {
      if (this.contractModule === 1) {
        this.handleSalesmanChange();
      } else {
        this.form.salesmanCode = this.value;
      }
    },
    handleSalesmanChange() {
      this.selectBusiList = [];
      this.form.businessId = '';
      this.selectBusiData.query = '';
    },
    getBusiSelectList() {
      return new Promise((resolve, reject) => {
        if (!this.form.salesmanCode || !this.busiSearchCustomId) {
          this.$message.info('请先选择客户及业务员');
          return;
        }
        this.busiSelectSearch({
          customerId: this.compactDetail.customerId,
          salesmanCode: this.form.salesmanCode,
          uid: this.busiSelectSearchUid,
          name: this.selectBusiData.query,
          pageSize: this.selectBusiData.pageSize,
          pageNumber: this.selectBusiData.pageIndex,
        })
          .then(() => {
            this.busiSelectSearchUid = '';
            if (this.selectBusiData.pageIndex === 1) {
              this.selectBusiList = [];
            }
            this.busiSelectData.results.forEach((item) => {
              this.selectBusiList.push(item);
            });
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleMoreBusiList() {
      this.isBusiMore = true;
      this.selectBusiData.pageIndex += 1;
      this.getBusiSelectList();
    },
    handleGetSalesman(customerUid) {
      return this.getCompactSalesman(customerUid).then(() => {
        this.customSalesman = this.compactSalesman;
      });
    },
    // 产品线
    handleChange() {
      // const checkedNodes = this.$refs['cascader'].getCheckedNodes();
      // this.form.businessLineName = checkedNodes[0].label;
    },
    async getAllProductLine() {
      service.queryProductLineList().then((res) => {
        res.data.data.forEach((item) => {
          this.allProductLine.push({
            ...item,
            id: item.typeCode,
            name: item.typeName,
          });
        });
      });
    },
  },
};
</script>

<style lang="less">
.updatecompact-container {
  padding-right: 30px;
  .dialog-footer {
    text-align: right;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>
